import { Component, OnInit } from '@angular/core';
import { FswService } from '@services/fsw.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '@services/auth.service';
import {  Color } from 'ng2-charts';

@Component({
  selector: 'app-so-dashboard',
  templateUrl: './so-dashboard.component.html',
  styleUrls: ['./so-dashboard.component.scss']
})
export class SoDashboardComponent implements OnInit {
    userRecord: any[] | undefined;
    userRecordCount: any = 0;
    public isCollapsed = false;
    metrics!: any[];
    awpRecord: any[] | undefined;
    awpRecordCount: any = 0;
    trainingRecord: any[] | undefined;
    trainingRecordCount: any = 0;;
    testingRecord: any[] | undefined;
    testingRecordCount: any = 0;
    chartViewType:any='Testing';

    doughnutChartLabels:any;
    doughnutChartData:any;
    doughnutChartType:any;

    stateName:any;
    stateCode:any;
    barChartTitle='Month Wise Sample Testing Status';
  
    constructor(private fswService: FswService, private authService: AuthService, private spinnerService: NgxSpinnerService) {
      
      //this.fswService.getTrainingList(this.userName)
      // .subscribe(res => {
      // debugger
      //    this.trainings = res;
  
      // })
      this.stateName = localStorage.getItem('STATENAME');
      this.stateCode = localStorage.getItem('STATE');
    }
    
   

    public barChartOptions = {
      scaleShowVerticalLines: false,
      responsive: true
    };
    // public barChartLabels = ['2006', '2007', '2008', '2009', '2010', '2011', '2012'];
    // public barChartType = 'bar';
    // public barChartLegend = true;
    // public barChartData = [
    //   {data: [65, 59, 80, 81, 56, 55, 40], label: 'Pass Samples'},
    //   {data: [28, 48, 40, 19, 86, 27, 90], label: 'Fail Samples'}
    // ];
    public barChartLabels = []//['2006', '2007', '2008', '2009', '2010', '2011', '2012'];
    public barChartType = 'bar';
    public barChartLegend = true;
    public barChartData = [
     // {data: [65, 59, 80, 81, 56, 55, 40], label: 'Tested Samples'}
      //,
      //{data: [28, 48, 40, 19, 86, 27, 90], label: 'Fail Samples'}
    ];
    public barChartColors: Color[] = [
      { backgroundColor: '#ffa1b5' },
      
     
    ]
    public donutColors=[
      {
       backgroundColor: [
      '#9d86c3',
       '#86c7f3',
       '#ffa1b5',
       '#ffe29a'
      
       ]
       }];
  
    // Metrics Variables
  
    panels = [
      { title: 'Recently subscribers', id: 'recently-subscribers-panel' },
      { title: 'Twitter trends', id: 'twitter-trends-panel' },
      { title: 'Most viewed youtube videos', id: 'most-viewed-yt-videos-panel' },
      { title: 'Facebook audience growth', id: 'fb-audience-growth-panel' }
    ];

    ngOnInit(): void { 

      this.doughnutChartLabels = ['Testing', 'Trainings', 'Awareness Programs', 'Vehicles'];
      this.doughnutChartData = [this.testingRecordCount, this.testingRecordCount, this.awpRecordCount, this.userRecordCount];
      this.doughnutChartType = 'doughnut';
      var stateCode = this.authService.getState();
      this.fswService.getVehicleListCount(stateCode).subscribe((data: any[]) => {
        // this.spinnerService.show();
        this.userRecord = data;
      
        this.userRecordCount = data[0].total;
        console.log(this.userRecordCount);
        //Testing Start
        this.fswService.getTestingListCount(stateCode)
          .subscribe(res => {
            debugger;
            if(res.length>0){
            this.testingRecord = res;
            this.testingRecordCount = res[0].total;
            }
            else
            {
              this.spinnerService.hide();
            }
  
            //Testing End
            //Training Start
            this.fswService.getTrainingListCount(stateCode)
              .subscribe(res => {
                if(res.length>0){
                this.trainingRecord = res;
                this.trainingRecordCount = res[0].total;
                }
                else
                {
                  this.spinnerService.hide();
                }
                //Training End
                //AWP Start
                this.fswService.getawpListCount(stateCode)
                  .subscribe(res => {
                    if(res.length>0){
                    this.awpRecord = res;
                    this.awpRecordCount = res[0].total;
                    }
                    else
                    {
                      this.spinnerService.hide();
                    }
                    this.doughnutChartLabels = ['Vehicles','Trainings','Testing',  'Awareness Programs' ];
                    this.doughnutChartData = [ this.userRecordCount, this.trainingRecordCount,this.testingRecordCount, this.awpRecordCount];
                    this.doughnutChartType = 'doughnut';
                    this.spinnerService.hide();
                    this.bindBarChart();
                    //AWP End
                   

                  })
              })
          })
      })
    }
    bindBarChart()
    {
      this.barChartLabels=[];
      this.barChartData=[];
      var chartData=[]; 
      console.log(this.stateCode);
      this.fswService.getActivityDetailsByNodelOfficer(this.chartViewType,this.stateCode)
      .subscribe(res => {
       if(res){
         debugger
         res.forEach(item=>{
           if(this.chartViewType=='Vehicle')
           {
           chartData.push(item.vehicle_register);
           this.barChartTitle='Month Wise Vehicle Registered';
           }
          if(this.chartViewType=='Trainings')
          {
           chartData.push(item.training_conducted)
           this.barChartTitle='Month Wise Trainings Conducted';
          }
          if(this.chartViewType=='Awareness Programs')
          {
          chartData.push(item.awareness_program_conducted)
          this.barChartTitle='Month Wise Awareness Programs Conducted';
          }
          if(this.chartViewType=='Testing')
          {
           chartData.push(item.sample_tested)
           this.barChartTitle='Month Wise Sample Testing Status';
          }
           this.barChartLabels.push(item.month_name+item.Year)
  
         })
         
         
         if(this.chartViewType=='Testing')
         {
         
          this.barChartColors[0]. backgroundColor= '#ffa1b5';
       
         this.barChartData = [{data:chartData, label: 'Sample Testing'}];
        
        
         }
         else if(this.chartViewType=='Trainings')
         {
          this.barChartColors[0]. backgroundColor= '#86c7f3';
         this.barChartData = [{data:chartData, label: 'Trainings'}]
         }
         else if(this.chartViewType=='Awareness Programs')
         {
          this.barChartColors[0]. backgroundColor='#ffe29a';
         this.barChartData = [{data:chartData, label: 'Awareness Programs'}]
         }
         else if(this.chartViewType=='Vehicle')
         {
          this.barChartColors[0]. backgroundColor='#9d86c3';
         this.barChartData = [{data:chartData, label: 'Vehicle'}]
         }
  
       }
      })
  
    }
    changeView()
    {
      //console.log(this.chartViewType);
      if(this.chartViewType!='')
      this.bindBarChart();  
    }
  

}
